

































































































































    import { Component, Vue, Watch } from 'vue-property-decorator';
    import ProductsSearch from '@/components/ProductsSearch.vue';
    import { BIcon } from 'bootstrap-vue'
    import axios from 'axios';
    import { General } from '../../services/General';
    import { saveAs } from 'file-saver';
  
    import { Validate } from 'vuelidate-property-decorators';
    import { required } from 'vuelidate/lib/validators'
    import HelpContent from '../HelpContent.vue';
import { __values } from 'tslib';


    @Component({
        components: {
            ProductsSearch,
            BIcon,
            HelpContent
        }
    })
    export default class CqcPage extends Vue {
        [x: string]: any;
        customer: any = null;
        @Validate({ required })
        order: string = '';
        languageSelected: any = null;
        loadingDocuments: boolean = false;
        searchCustomerVisible: boolean = true;
        searchCustomerValue: string = '';
        productsSelected: any[] = null;
        @Validate({ required })
        customerHeader: string = '';
        languageList: any[] = [];
        optionsLanguage: any = new Array();
        buildCqcButtonEnabled: boolean = true;
        buildCqcWaiting: boolean = false;
        startValidation: boolean = false;
        public get prdFields(): Array<object>{
            return    [
            {
                key: 'code',
                label: this.$t('PRODUCT.PRODUCT_CODE'),
                sortable: false
            },
            {
                key: 'description',
                label: this.$t('GENERAL.DESCRIPTION'),
                sortable: false
            },
            {
                key: 'language',
                label: this.$t('GENERAL.LANGAUGE')
            },
            {
                key: 'idProduct',
                label: '',
                formatter: value => {
                    return this.$options.filters.empty(value);
                }
            }
        ]
    };
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        }
        getResultValue(result) {
            return result.header;
        }
        customerSelected(customer: any) {
            if (customer!=null){
                this.customer = customer;
                this.customerHeader = customer.header;
                this.searchCustomerVisible = false;
            }
        }
        @Watch('customerHeader')
        customerHeaderChange(customer: string) {
            if (customer.length == 0) {
                this.searchCustomerVisible = true;
            } else {
                this.searchCustomerVisible = false;
            }
        }
        remove(item: any) {
            General.confirm( this.$t('CQC.QUESTION_REMOVE_PRODUCT') as string, this, () => {
                let index = this.productsSelected.findIndex((element) => element.idProduct == item.idProduct);
                console.log(index);
                this.productsSelected.splice(index, 1);
            });
        }
        productsSelectedChange(itemsSelected: any) {
            this.productsSelected = itemsSelected;
        }
       
        async summaryCqc() {
           
            this.startValidation = true;
            (this as any).$v.$touch();
            if ((this as any).$v.$invalid) {
                //window.scrollTo(0, 0);
                this.scrollTop();
                return;
            }
            await this.getAvailableDocuments();
            this.$bvModal.show('build-modal');
           
        }
        reset() {
            General.confirm(this.$t('CQC.QUESTION_RESET') as string, this, () => {
                this.startValidation = false;
                this.productsSelected.splice(0);
                this.customerHeader = '';
                this.customer = null;
                this.order = '';
                (this.$refs['productsSearch'] as any).resetSearch();
                this.$bvModal.hide('build-modal');
                this.languageSelected = null;
            });
        }
        IsValidateField(fieldValid: boolean): boolean {
            if (this.startValidation && !fieldValid) {
                return false;
            }
            return true;
        }
        async buildCqc() {
            if (!this.checkDocument(this.productsSelected)) {
                General.showAlertInfo(this.$t('CQC.WITHOUT_DOCUMENTS') as string, this);
            } else {
                this.buildCqcButtonEnabled = false;
                this.buildCqcWaiting = true;
                try {
                    let response = await axios({
                        method: 'post',
                        url: General.GetApiUrl('/api/cqc/DownloadCQCPdf'),
                        data: {
                            ProductsSelected: this.productsSelected,
                            SelectedLanguage: this.languageSelected,
                            CustomerHeader: this.customerHeader,
                            Order: this.order
                        },
                        withCredentials: true,
                        responseType: 'blob'
                    });
                    
                    let fileName = General.getFileNameFromHeader(response.headers);
                   
                    saveAs(new Blob([response.data]), fileName);
                    
                   
                } catch (error) {
                    try {
                        let responseObjText = await error.response.data.text();
                       
                        let responseObj = JSON.parse(responseObjText);
                        console.log(responseObj.detail)

                        General.showAlertDanger(responseObj.detail, this);
                       
                    } catch {
                        General.HandleError(error, this);
                    }
                } finally {
                    this.buildCqcButtonEnabled = true;
                    this.buildCqcWaiting = false;
                }

            }
        }
        async getLanguages(emptyPolicy: boolean) {
            try {
                let apiUrl = General.GetApiUrl('/api/culture/GetLanguages/?emptyLanguagesPolicy=' + ((emptyPolicy == true) ? '1' : '0'));
                let response: any = await axios({
                    method: 'get',
                    url: apiUrl,
                    responseType: 'json'
                });
                this.languageList = this.convertLanguageToSelect(response.data, false);
                


            } catch (error) {
                General.HandleError(error, this);
            }
        }
        
        getLanguageText(idLanguage: string): string{
            let language:any = this.languageList.find(item => item.value == idLanguage)
            if (language) return language.text;
            return '';
        }
        async getAvailableDocuments() {
            
            if (this.languageSelected == null) {
                this.resetDocuments()
                return;
            }
            this.loadingDocuments = true;
            try {
                var productsSelected = this.productsSelected;
                var selectedLanguage = this.languageSelected;
                let response = await axios({
                    method: 'post',
                    url: General.GetApiUrl('/api/cqc/GetAvailableDocuments'),
                    data: {
                        ProductsSelected: productsSelected,
                        SelectedLanguage: selectedLanguage
                    },
                    withCredentials: true,
                    responseType: 'json'
                });

                for (var i = 0; i < productsSelected.length; i++) {
                    let documents = [];
                    let languageName: string = ''; 
                    for (var j = 0; j < response.data.length; j++)
                        
                        if (productsSelected[i].idProduct == response.data[j].item1) {
                            
                            
                            documents.push({
                                IdDocument: response.data[j].item3,
                                Culture: response.data[j].item2
                            });

                            languageName = response.data[j].item2.language.name;
                            break;
                        }
                    Vue.set(productsSelected[i], 'languageName', languageName);
                    Vue.set(productsSelected[i], 'documents', documents);
                }
                
            } catch (error) {
                General.HandleError(error, this);
            }
            this.loadingDocuments = false;
        }
        resetDocuments() {
            for (var i = 0; i < this.productsSelected.length; i++) {
                        
                Vue.set(this.productsSelected[i], 'languageName', null);
                Vue.set(this.productsSelected[i], 'documents', null);
                   
            }

        }
        checkDocument(products: any[]) {
            let result: boolean = true;;
            products.forEach(item => {
                if (item.documents == null || item.documents.length == 0)
                    result = false;
                    return;
            });
            return result;
        }
        convertLanguageToSelect(data: any, addEmpty: boolean) {
            let outputData = new Array();
            if (addEmpty) outputData.push({ value: null, text: this.$t('CQC.SELECT_LANGAUGE') });
            data.forEach(function (item: any) {
                outputData.push({
                    value: item.idLanguage,
                    text: item.name,
                    code: item.code
                });
            });
            return outputData;
        };
       
        async mounted() {            
            await this.getLanguages(true);
            
            var defaultLang = this.languageList.find(item => item.code == 'en');
            if (defaultLang != undefined) this.languageSelected = defaultLang.value;

        };
        scrollTop() {
            var intervalId = setInterval(() => {
                if (window.pageYOffset === 0) {
                    clearInterval(intervalId);
                }
                window.scroll(0, window.pageYOffset - 100)
            }, 5)
        }
    }
